import type { PermissionState } from "./model";
import type { RouteRecordRaw } from "vue-router";
import { defineStore } from "pinia";
import { getMenuList } from "./api";
import { WHITE_LIST_ROUTERS } from "@/app/router/constants";
import { toMenuRoutes, transformRoutes } from "@/app/router/route-transform";

let pendingRoutesRequest: Promise<RouteRecordRaw[]> | null = null;

export const usePermissionStore = defineStore("permission", {
  state: (): PermissionState => ({
    whiteListRouters: [...WHITE_LIST_ROUTERS],
    routers: [],
    asyncRoutes: [],
    apiPermissionList: [],
    routesLoaded: false,
    routesFetchedAt: 0,
  }),
  getters: {
    menuRoutes: (state) => toMenuRoutes(state.routers),
  },
  actions: {
    initRoutes() {
      this.routers = [...this.asyncRoutes];
    },
    shouldRefreshRoutes(ttl: number) {
      return !this.routesLoaded || Date.now() - this.routesFetchedAt > ttl;
    },
    async buildAsyncRoutes(): Promise<RouteRecordRaw[]> {
      if (pendingRoutesRequest) {
        return pendingRoutesRequest;
      }

      pendingRoutesRequest = this.fetchAsyncRoutes().finally(() => {
        pendingRoutesRequest = null;
      });

      return pendingRoutesRequest;
    },
    async fetchAsyncRoutes(): Promise<RouteRecordRaw[]> {
      const { list, permissions } = await getMenuList();
      this.asyncRoutes = list;
      this.apiPermissionList = permissions;
      this.routesLoaded = true;
      this.routesFetchedAt = Date.now();
      this.initRoutes();
      return transformRoutes(list);
    },
    restoreRoutes() {
      this.asyncRoutes = [];
      this.routers = [];
      this.apiPermissionList = [];
      this.routesLoaded = false;
      this.routesFetchedAt = 0;
    },
  },
});
